module.exports = __webpack_public_path__ + "img/Autocolant TCLHE_150mm x 180mm-01.ffc1e29b.jpg";